module.exports = __webpack_public_path__ + "img/sneakers-maker-poster.f10d8218.jpg";